import "@fontsource/montserrat/700.css";

// Colours for the redesigned Track page and its top bar.
export const trackColours = {
    green: "#0B3B2E",
    greenHover: "#082C22",
    gold: "#C9A35B",
    goldText: "#8C6A2A",
    goldSoft: "#F3E9D2",
    cream: "#F5F0E7",
    card: "#FFFFFF",
    border: "#E7E0D2",
    text: "#14281F",
    muted: "#5E6A64",
    faint: "#C9CFCB",
};

export const chipTones = {
    green: {background: "#E3F1E6", color: "#1D6B3A"},
    grey: {background: "#ECEBE7", color: "#545E59"},
    amber: {background: "#FBE9CF", color: "#8A5512"},
    red: {background: "#F6E0DD", color: "#962D22"},
};
